import { useQuery } from "@tanstack/react-query";
import { vaultCashKeys } from "apis/salary/query_keys_salary";
import { getVaultCashBalance } from "apis/salary/vaultcash_manage_api";

import { simpleAlert } from "components/CommonLib/CommonLib";
import { useDispatch } from "react-redux";

// [GET] 시재금 잔액 조회
export const useVaultCashBalance = (queryData) => {
  const storesDispatch = useDispatch();
  const { branchId } = queryData;

  return useQuery({
    queryKey: vaultCashKeys.balance(queryData),
    queryFn: () => getVaultCashBalance(queryData),
    enabled: !!branchId,
    retry: false,
    cacheTime: 0,

    onSuccess: (res) => {
      if (res.data.msg) {
        simpleAlert(storesDispatch, "알림", res.data.msg);
      }
    },
    onError: (err) => {
      simpleAlert(storesDispatch, "ERROR", err.response.data ? err.response.data.msg : err.code);
    },
  });
};
